import { observer } from 'mobx-react-lite';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = observer(() => {
  const { user, isInitializing } = useAuth();
  const location = useLocation();

  //localStorage 復元中はまだ何も描画しない
  if (isInitializing) {
    return null;
  }

  if (user) {
    return <Outlet />;
  } else {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
});

export default PrivateRoute;
